import { DateTime } from 'luxon';
import cloneDateTime from './cloneDateTime';
import isSameDay from './isSameDay';

export default function isNextDay(a, b) {
  if (!(a instanceof DateTime) || !(b instanceof DateTime)) return false;
  
  
  const nextDay = cloneDateTime(a).plus({ days: 1 });
  return isSameDay(nextDay, b);
}
